module.exports = __webpack_public_path__ + "img/hempel-yacht.55b4eaa4.png";